/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';

import "alpinejs";

// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faFacebook, faTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faSignOutAlt, faSignInAlt, faShoppingBag, faShippingFast, faMoneyBillAlt, faBadgeCheck, faClipboardListCheck, faPhoneVolume, faMoneyBillWave, faUser, faBars, faSearch, faGolfBall, faGolfClub, faCloudHail, faBullhorn, faCommentDollar } from '@fortawesome/pro-light-svg-icons';

// add the imported icons to the library
library.add(faFacebook, faTwitter, faInstagram, faLinkedin, faSignOutAlt, faSignInAlt, faShoppingBag, faShippingFast, faMoneyBillAlt, faBadgeCheck, faClipboardListCheck, faPhoneVolume, faMoneyBillWave, faUser, faBars, faSearch, faGolfBall, faGolfClub, faCloudHail, faBullhorn, faCommentDollar );

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();
